// extracted by mini-css-extract-plugin
export var layoutContainer = "_3n-0";
export var layoutContainerOpen = "_3n-3";
export var mainContent = "_3n-1";
export var panelLarge = "_3n-6";
export var panelMedium = "_3n-5";
export var panelSmall = "_3n-4";
export var slidePanel = "_3n-2";